module.exports = __webpack_public_path__ + "clock.27c123dee78e8845ce3d";


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/assets/img/admin/clock.jpg
// module id = ../../../../../src/assets/img/admin/clock.jpg
// module chunks = monitor-agents.module